import React, { useState, useEffect, useRef } from "react";
import useAxios from "../../hooks/useAxios";
import { PageToolbar, TooltipWrapper } from "../common";
//Helper function, external library and Interfaces
import helpers from "../../_helpers/common";
import { useParams } from "react-router-dom";
import { ProductAsset, Order } from "../../types/interfaces";
import { QRCodeCanvas as QRCode } from "qrcode.react";

const OrderInvoice: React.FC = () => {	
  const axiosInstance = useAxios();
  const { order_id } = useParams();
  const [data, setData] = useState<Order | null>(null);
  const [copied, setCopied] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [loadingpdf, setLoadingPdf] = useState(false);
  const [loadinglabel, setLoadingLabel] = useState(false);
  const [currency] = useState("Rs ");
  const initialRequest = useRef(false);
  //console.log('order_id', order_id);
  
  useEffect(() => {
  //console.log("useEffect fired", order_id);

  if (order_id) {
    getDetailData();
  }
}, [order_id]);

 

  const getDetailData = async () => {
    try {
	  //console.log('comming to get details data');	
	  setIsLoading(true);	
      const response: any = await axiosInstance({
        url: "orders/detail",
        method: "GET",
        data: { orderId: order_id },
      });
      //console.log("order details response", response);
      setData(response.data.order);
    } catch (error: any) {
      console.error("Error in api request:", error);
    } finally {
	  setIsLoading(false);	
	}
  };
   // ---------------- DOWNLOAD PDF ----------------
  const downloadPDF = async () => {
    if (!data) return;

    try {
      setLoadingPdf(true);

      const html = document.getElementById("pdf-content")?.innerHTML || "";

      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}orders/genereate-order-pdf`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ html }),
        }
      );

      if (!response.ok) throw new Error("PDF generation failed");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `${data.order_number}-invoice.pdf`;
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      alert("Failed to generate PDF");
    } finally {
      setLoadingPdf(false);
    }
  };
  
  // ---------------- DOWNLOAD SHIPPINNG LABEL ----------------
  const downloadShippingLabel = async () => {
    if (!data) return;
    try {
      setLoadingLabel(true);

      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}orders/genereate-shipping-label/${order_id}`,
        {
          method: "GET",
        }
      );

      if (!response.ok) throw new Error("PDF generation failed");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `${data.order_number}-shipping-label.pdf`;
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      alert("Failed to generate shipping label");
    } finally {
      setLoadingLabel(false);
    }
  };
  if (isloading) {
	  return <div>Loading...</div>;
	}

	if (!data) {
	  return <div>No data found</div>;
	}
  //console.log('data', data);
  return (
  <>
  {isloading ? (
    <div>Loading Data</div>
  ) : (
    <div id="kt_app_content" className="flex-column-fluid">

	{/* BUTTON */}
	<div className="d-flex justify-content-end mb-3 gap-2">
	 <button
		onClick={downloadShippingLabel}
		disabled={loadinglabel}
		className="btn btn-info px-4 py-2 d-flex align-items-center gap-2"
	  >
		{loadinglabel ? (
		  <>
			<span className="spinner-border spinner-border-sm"></span>
			<span>Generating Label...</span>
		  </>
		) : (
		  <>
			<i className="fa fa-download"></i>
			<span>Download Shipping Label</span>
		  </>
		)}	
	  </button>
	  <button
		onClick={downloadPDF}
		disabled={loadingpdf}
		className="btn btn-primary px-4 py-2 d-flex align-items-center gap-2"
	  >
		{loadingpdf ? (
		  <>
			<span className="spinner-border spinner-border-sm"></span>
			<span>Generating PDF...</span>
		  </>
		) : (
		  <>
			<i className="fa fa-download"></i>
			<span>Download PDF</span>
		  </>
		)}
	  </button>
	</div>
    <div id="pdf-content" className="bg-white p-5 shadow rounded">
      {/* HEADER */}
      <div className="d-flex justify-content-between border-bottom pb-3">
        <div>
          <h2 className="fw-bold">AstroUshaa</h2>
          <p className="text-muted">Align Your Stars</p>
        </div>

        {data?._id && <QRCode value={data._id} size={80} />}
      </div>

      {/* INVOICE DETAILS */}
      <div className="row mt-4 border-bottom pb-3">
        <div className="col-md-6">
          <h4 className="fw-bold">INVOICE</h4>
          <p>
            <strong>Invoice No:</strong> {data.invoice_number}
          </p>
          <p>
            <strong>Order No:</strong> {data.order_number}
          </p>
          <p>
            <strong>Date:</strong>{" "}
            {new Date(data.created_at).toLocaleDateString()}
          </p>

          <p className="mt-2">
            <strong>Status:</strong>{" "}
            <span
              className={
                data.payment_status === "Paid"
                  ? "text-success fw-semibold"
                  : data.payment_status === "Pending"
                  ? "text-warning fw-semibold"
                  : "text-danger fw-semibold"
              }
            >
              {data.payment_status}
            </span>
          </p>
        </div>

        <div className="col-md-6 text-md-end">
          <p className="fw-bold">Billed To:</p>

          <p>
            {typeof data.created_by === "object"
              ? data.created_by.fullname
              : data.created_by}
          </p>

          <p>{data.shipping_address}</p>

          <p>
            {typeof data.created_by === "object"
              ? data.created_by.phone_no
              : ""}
          </p>

          <p>
            {typeof data.created_by === "object"
              ? data.created_by.email
              : ""}
          </p>
        </div>
      </div>

      {/* ORDER ITEMS */}
      <div className="table-responsive mt-4">
        <table className="table table-bordered align-middle">
          <thead className="table-light">
            <tr>
              <th>Item</th>
              <th className="text-center">Qty</th>
              <th className="text-center">Price</th>
              <th className="text-center">Discount</th>
              <th className="text-end">Total</th>
            </tr>
          </thead>

          <tbody>
            {data.order_items?.map((item: any, index: number) => {
              const qty = Number(item.quantity);
              const price = Number(item.price);
              const discount = Number(item.discount || 0);
              const discountedPrice = price - discount;

              return (
                <tr key={index}>
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      {item.product_id?.displaypath && (
                        <img
                          src={item.product_id.displaypath}
                          alt="product"
                          className="rounded border"
                          style={{
                            width: 50,
                            height: 50,
                            objectFit: "cover",
                          }}
                        />
                      )}

                      {item.product_id?.title || "Product"}
                    </div>
                  </td>

                  <td className="text-center">{qty}</td>

                  <td className="text-center">
                    {currency}
                    {price.toFixed(2)}
                  </td>

                  <td className="text-center">
                    {discount
                      ? `-${currency}${discount.toFixed(2)}`
                      : "—"}
                  </td>

                  <td className="text-end">
                    {currency}
                    {(discountedPrice * qty).toFixed(2)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* SUMMARY */}
      <div className="mt-4">
        <SummaryRow
          label="Subtotal:"
          value={`${currency}${Number(data.items_price).toFixed(2)}`}
        />

        <SummaryRow
          label="Tax:"
          value={`${currency}${Number(data.tax_price).toFixed(2)}`}
        />

        <SummaryRow
          label="Shipping:"
          value={`${currency}${Number(data.shipping_price).toFixed(2)}`}
        />

        <div className="d-flex justify-content-between border-top pt-3 mt-2 fw-bold fs-5">
          <span>Total:</span>

          <span>
            {currency}
            {Number(data.total_price).toFixed(2)}
          </span>
        </div>
      </div>

      {/* TRACKING */}
      {data.tracking_number && (
        <p className="mt-4">
          <strong>Tracking Number:</strong> {data.tracking_number}
        </p>
      )}

      {/* NOTES */}
      {data.notes && (
        <div className="alert alert-secondary mt-4">
          <strong>Notes:</strong>
          <p className="mb-0">{data.notes}</p>
        </div>
      )}

      {/* FOOTER */}
      <div className="text-center text-muted mt-5 pt-3 border-top">
        <p>Thank you for shopping with AstroUshaa!</p>
        <p>Customer Support: astroushaa@gmail.com</p>
      </div>
    </div>
	</div>
  )}
  </>
  );
};

const SummaryRow = ({
  label,
  value,
}: {
  label: string;
  value: string;
}) => (
  <div className="d-flex justify-content-between">
    <span className="fw-medium">{label}</span>
    <span>{value}</span>
  </div>
);

export default OrderInvoice;